import { Editor } from '@tiptap/core';

/**
 * Return selected dom node in the current selected table cells
 * This node uses for calculation of bounding box around selected text.
 *
 * @param editor - The editor instance
 * @returns
 */
const getSelectedNode = (editor: Editor): HTMLElement | undefined => {
  if (!editor || !editor.view.state.selection.ranges?.length) return undefined;

  const node = editor.view.domAtPos(editor.view.state.selection.anchor)?.node;

  if (!node) return undefined;

  // If it is a text leaf node, return its parent node
  if (node.nodeType === Node.TEXT_NODE) return node.parentElement ?? undefined;

  // Search first text node in giving selected node, fallback to itself if not found
  const targetNode = node.parentElement?.querySelector('span') ?? node;

  return targetNode as HTMLElement;
};

export { getSelectedNode };
